export default __webpack_public_path__ + "static/media/IMG_9779.bef1455d.JPG";